<template>
  <v-card flat>
    <v-card-title class="subheader py-0">
      <v-icon small class="mr-1" color="orange">money</v-icon>
      项目到款
      <v-spacer/>
      <v-btn flat round color="primary" dark
             :disabled="!funcIds.includes('c_proj_inco') || project.statusId !== 'checked'"
             @click.native.stop="
             () => {
                  editDbid = null;
                  projTypeId = project.typeId;
                  editDefault = getDefault();
                  edit = true;
                }">
        <v-icon>add</v-icon>
        新增到款
      </v-btn>
    </v-card-title>
    <v-divider color="orange"/>

    <v-card-text class="pt-0">
      <v-data-table
          :headers="headers"
          :items="items"
          hide-actions
          class="elevation-0 dense"
          no-data-text="没有数据。"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.index + 1 }}</td>
          <td class="">{{ props.item.amount | currency }}</td>
          <td class="">{{ props.item.paymentDate }}<br/>{{ props.item.userName }}</td>
          <td class="">{{ props.item.drawee }}</td>

          <td class="" v-if="props.item.kyYwTrans">
            自动,{{ props.item.kyYwTrans.pch }}<br/>
            <span v-if="props.item.kyYwTrans.iscl" style="color: steelblue">财务已处理</span>
            <span v-else>财务未处理</span>
          </td>
          <td class="" v-else>手工</td>

          <td class="justify-center layout px-0">
            <v-tooltip top>
              <v-btn icon class="mx-0" slot="activator"
                     @click="
                         () => {
                            viewDbid = props.item.dbid; view = true;
                         }">
                <v-icon color="teal">more_horiz</v-icon>
              </v-btn>
              <span>查看</span>
            </v-tooltip>

            <v-tooltip top>
              <v-btn icon class="mx-0" slot="activator"
                     :disabled="!funcIds.includes('c_proj_inco')"
                     @click="
                         () => {
                            printDbid = props.item.dbid;
                            print = true;
                         }">
                <v-icon color="teal">print</v-icon>
              </v-btn>
              <span>打印</span>
            </v-tooltip>

            <v-tooltip top>
              <v-btn
                  icon class="mx-0" slot="activator"
                  :disabled="!funcIds.includes('u_proj_inco')"
                  @click="
                     () => {
                        editDbid = props.item.dbid;
                        projTypeId = project.typeId;
                        editDefault = {};
                        edit = true;
                     }">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <span>编辑</span>
            </v-tooltip>

            <v-tooltip top>
              <v-btn
                  icon class="mx-0" slot="activator"
                  :disabled="!funcIds.includes('d_proj_inco')"
                  @click="onConfirmDelete(props.item)">
                <v-icon color="pink">delete_forever</v-icon>
              </v-btn>
              <span>删除</span>
            </v-tooltip>
          </td>

        </template>
      </v-data-table>
<!--      <p v-if="balance" class="pl-4 pt-1"-->
<!--         style="font-weight: 400;font-size: 13px; margin-bottom: 0; border-top: lightgrey 1px solid" >-->
<!--        经费余额: {{Number(balance.xmje) | currency}} 元-->
<!--      </p>-->
    </v-card-text>

    <x-view
        v-model="view"
        :dbid="viewDbid"/>

    <x-print
        v-model="print"
        :dbid="printDbid"
        :buget="bugetManage"
        :project="printProj"/>

    <x-edit
        v-model="edit"
        :dbid="editDbid"
        :proj-type-id="projTypeId"
        :default="editDefault"
        :leaderId="project.leaderId"
        :projId="project.dbid"
        :deptId="project.deptId"
        :adminDeptId="project.adminDeptId"
        v-on:ok="onEditOk"/>

    <x-delete
        v-model="dele"
        :message="deleMsg"
        :uri="uri"
        :dbid="deleDbid"
        v-on:ok="onDeleOk"/>

  </v-card>
</template>
<script>
import {mapGetters} from 'vuex'

import XEdit from './Edit'
import XView from './View'
import XPrint from './Print'

import XDelete from '@/components/global/Delete'
import Vue from "vue";

const baseURI = '/api/proj/fund/income';
const balanceURI = '/api/proj/fund/balance';
const getBugetUri = '/api/proj/project/buget';
const getclaimedProjCountURI = '/api/proj/fund/income/claimed/projcount';

export default {
  components: {XEdit, XDelete, XView, XPrint},

  props: {
    project: Object
  },

  data: () => ({
    uri: baseURI,
    headers: [
      {
        text: '#',
        sortable: false,
        value: 'dbid',
        width: '20'
      },
      {text: '金额(元)', value: 'amount', sortable: false, width: 120},
      {text: '到款日期/操作人', value: 'paymentDate', sortable: false, width: 120},
      // {text: '操作人', value: 'userName', sortable: false},
      {text: '汇款单位', value: 'drawee', sortable: false},
      {text: '建帐方式', value: 'dbid', sortable: false, align: 'left', width: 180},
      {text: '操作', value: 'dbid', sortable: false, align: 'center', width: 120}
    ],

    items: [],

    balance: null,

    buget : null,
    bugetManage : '',

    view: false,
    viewDbid: null,

    print: false,
    printDbid: null,
    printProj: null,

    edit: false,
    editDbid: null,
    projTypeId: null,
    editDefault: {},

    dele: false,
    deleDbid: null,
    deleMsg: null,
  }),

  computed: {
    ...mapGetters(['funcIds'])
  },

  watch: {
    project(p) {
      this.printProj = window.xutil.clone(p);
      this.axios.all([
        this.axios.get(`${baseURI}?projectId=${p.dbid}`),
        this.axios.get(`${balanceURI}/${p.dbid}`),
        this.axios.get(`${getBugetUri}/${p.dbid}`),
      ]).then(this.axios.spread(
          (rspInco, rspBala, rspBuget) => {
            // window.console.log("test!")
            this.items = rspInco.data.items;
            this.balance = rspBala.data;
            this.buget = rspBuget.data
            if (rspBuget.data.length > 0) {
              window.console.log("存在预算！")
              this.bugetManage = '科目管理'
            }
            else
            {
              window.console.log("不存在预算！")
              this.bugetManage = '余额管理'
            }
          }))
    }
  },

  methods: {
    getDefault() {
      return {
        projectId: this.project.dbid,
        drawee: this.project.client,
        serialNum: this.items.length + 1,
        property: !this.items.length ? '新立' : '追加',
        paymentDate: window.xutil.today(),
      }
    },
    onEditOk(item) {
      //console.log("in Income onEditOK");
      if (item) {
        if (!this.editDbid) {
          this.items.unshift(item);
        } else {
          const editIdx = this.items.findIndex(v => v.dbid === item.dbid);
          this.items[editIdx] = window.xutil.clone(item);
        }
        this.items = this.items.sort((a, b) => a.paymentDate >= b.paymentDate);
      }
    },
    onDeleOk(item) {
      if (item) {
        const deleIdx = this.items.findIndex(v => v.dbid === item.dbid);
        this.items.splice(deleIdx, 1);
      }
    },

    onConfirmDelete(item) {
      const vm = this
      window.console.log(item)
      this.axios.get(`${getclaimedProjCountURI}/${item.pznm}`)
          .then(
              rsp =>  {
                window.console.log("rsp.data")
                window.console.log(rsp.data.length)
                if(rsp.data.length > 1)
                {
                  alert("该笔到款为批量到款建帐，请到批量到款操作页面进行删除！")
                }
                else
                {
                  vm.deleDbid = item.dbid;
                  vm.deleMsg = `${item.amount}元 / ${item.paymentDate} / ${item.drawee}`;
                  vm.dele = true;
                }
              }
          )
    }
  }
}
</script>
